(function() { window.GUID_e1af185d_3e7c_4420_b001_0bee191873eb = { getGuid: function() { return "e1af185d-3e7c-4420-b001-0bee191873eb"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-teammembers",
                        callback: function (control, e) {
                            CS.Controls.CheckBox.Events.CheckboxValueChanged({
                                selector: ".team-notif-checkbox",
                                callback: (control, params) => {
                                    let teamId = control.$Control
                                        .parents(".team-notifications")
                                        .data("teamid");
                                    let isSubscribed = control.IsChecked;
                                    let data = {
                                        teamId: teamId,
                                        isSubscribed: isSubscribed,
                                    };
                                    CS.Ajax.Post($("#csurl-updateteamnotificationsubscription").val(), data, function (response) {
                                        if (response.success) {
                                            CS.Controls.Snackbar.Show({
                                                Id: "team-notifications-updated",
                                                Message: response.message,
                                                AutoHideDuration: 5000,
                                                Type: isSubscribed
                                                    ? CS.Enumeration.SnackbarType.Success
                                                    : CS.Enumeration.SnackbarType.Info,
                                                Alignment: CS.Enumeration.SnackbarAlignment.BottomCenter,
                                                Animation: CS.Enumeration.SnackbarAnimation.SlideUp,
                                            });
                                        }
                                    });
                                },
                            });
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=team-members.js.map
